import { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import Pills from "../Pills";
import styles from "./index.css";
import LargeViewportDescription from "./LargeViewportDescription";
import { LARGE_VIEWPORT } from "../../../state/modules/layout/constants";

const renderWithNoDescription = hasPills =>
  hasPills ? (
    <div className={styles.expanded}>
      <Pills />
    </div>
  ) : null;

class CategoryDescription extends Component {
  static propTypes = {
    description: PropTypes.string,
    hasPills: PropTypes.bool.isRequired,
    viewport: PropTypes.string.isRequired,
    formatTranslation: PropTypes.func.isRequired,
    analyticsClickMoreMvt: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      expanded: false
    };
  }

  componentDidUpdate(prevProps) {
    const { viewport } = this.props;

    if (prevProps.viewport !== viewport) {
      this.setState({ expanded: false });
    }
  }

  onButtonClick = () => {
    this.setState({ expanded: !this.state.expanded }, () => {
      this.state.expanded && this.props.analyticsClickMoreMvt();
    });
  };

  render() {
    const { description, hasPills, formatTranslation, viewport } = this.props;
    const { expanded } = this.state;

    if (!description) {
      return renderWithNoDescription(hasPills);
    }

    return viewport === LARGE_VIEWPORT ? (
      <div className={styles.categoryDescription}>
        <LargeViewportDescription
          formatTranslation={formatTranslation}
          expanded={expanded}
          description={description}
          onButtonClick={this.onButtonClick}
        />
        <Pills />
      </div>
    ) : (
      <div className={styles.categoryDescription}>
        <p
          className={classnames(styles.description, {
            [styles.expanded]: expanded
          })}
        >
          {description}
        </p>
        <Pills show={expanded} />
        <button
          className={styles.readMore}
          onClick={this.onButtonClick}
          data-auto-id="categoryReadMore"
        >
          {expanded
            ? formatTranslation("plp_web_view_less_button_label")
            : formatTranslation("plp_web_view_more_button_label")}
        </button>
      </div>
    );
  }
}

export default CategoryDescription;
